import { createGlobalStyle } from 'styled-components';
import media from 'styled-media-query';

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 100%;
  }
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Segoe UI',
      'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Arial, Meiryo, sans-serif;
  }
  :root {
    --main-width: 40rem;
    --card-num: 2;
    ${media.lessThan('large')`
    --main-width: 35rem;
    `}
    ${media.lessThan('medium')`
      --main-width: 95vw;
      --card-num: 1;
    `}
    --card-gap: 2rem;
    --card-width: calc(
      (var(--main-width) - var(--card-gap) * (var(--card-num) - 1)) /
        var(--card-num)
    );
    --font-color: #444;
  }
`;
